<template lang="pug">
  .b-rooms-select
    ._rooms
      ._room(v-for="(room, i) in rooms" :key="i")
        BaseInput._room-name(type="text" v-model="room.name" :error="getError(room.name)" @change="onChange()" label="Помещение" ref="input")
        BaseInput._room-area(type="text" v-model="room.area" :error="getError(room.area)" @change="onChange()" label="Площадь, м²")
        ._btn-remove-room(@click="removeRoom(i)")
      ._footer
        Btn._btn-add-room(dark xl @click.native="addRoom")
          Icon(name="plus" pointer)
          | Добавить помещение
        ._error(v-if="!isValid && showError") Для создания проекта по шаблону необходимо добавить хотя бы одно помещение.
    ._info(v-if="isCreating") Для каждого помещения на каждом этапе дизайн-проекта будет создана задача. При этом вы можете добавлять, редактировать и удалять задачи в любой момент.
      BaseCheckbox._create-stages(v-if="isCreating" v-model="useRooms" label="Создать разделы" @change="onChange()")
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';

export default {
  name: 'RoomSelect',
  components: { BaseCheckbox, BaseInput },
  props: {
    value: [Object, Array],
    isCreating: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.useRooms = val.useRooms ?? true;
        this.rooms = val.rooms ?? [];
      },
    },
  },
  data() {
    return {
      rooms: [],
      useRooms: true,
      showError: false,
    };
  },
  computed: {
    hasFilledRooms() { return this.rooms.filter(r => r.name).length; },
    hasEmptyRooms() { return this.rooms.filter(r => !r.name).length; },
    isValid() { return !this.isCreating || !this.useRooms || (this.hasFilledRooms && !this.hasEmptyRooms); },
  },
  methods: {
    getError(val) {
      return !val && this.showError ? 'Это поле обязательно' : '';
    },
    validate() {
      if (this.isValid) return true;

      this.showError = true;
      if (!this.hasEmptyRooms) {
        this.addRoom();
      }
      return false;
    },
    addRoom() {
      this.rooms.push({ name: '', area: '' });
      this.$nextTick(() => {
        const inputs = this.$refs.input;
        inputs[inputs.length - 1].$el.querySelector('input').focus();
      });
    },
    removeRoom(i) {
      this.rooms.splice(i, 1);
      this.onChange();
    },
    onChange() {
      const { rooms, useRooms } = this;
      this.$emit('input', { rooms, useRooms });
    },
  },
};
</script>

<style scoped lang="scss">
.rooms-select {
  display: flex;
  justify-content: space-between;

  &__rooms {
    flex-grow: 1;
    margin-bottom: 20px;
  }

  &__room {
    display: flex;
    margin-bottom: 16px;
  }

  &__footer {
    display: flex;
    align-items: flex-start;
    gap: 25px;
  }

  &__room-name {
    flex-basis: 50%;
    margin-right: 12px;
  }

  &__room-area {
    flex-basis: 50%;
    margin-right: 12px;
  }

  &__btn-remove-room {
    margin-right: 12px;
    display: inline-block;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 16px;
    background-color: var(--main-bg);
    background-image: url(../assets/img/svg/close2.svg);
    background-position: center;
    background-size: 16px;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  &__error {
    border-radius: 8px;
    background: #FFE0CC;
    padding: 15px 13px;
    color: #1E3147;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 290px;
  }

  &__info {
    position: relative;
    max-width: 232px;
    box-sizing: border-box;
    padding-left: 38px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: .01em;
    color: var(--color-middle-gray);

    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 24px;
      background-image: url(../assets/img/svg/question-circle.svg);
      background-size: cover;
    }
  }

  &__create-stages {
    margin: 10px 0 0 -35px;

    &::v-deep {
      gap: 15px;

      .label {
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        letter-spacing: 0.01em;
        color: #33A1FB;
        text-decoration: underline dashed;
        text-underline-offset: .3em;
      }
    }

    &:hover::v-deep .label {
      text-decoration: none;
    }
  }

  @media (max-width: 1366px) {
    flex-wrap: wrap;

    &__info {
      max-width: none;
    }
  }
  @media (max-width: 576px) {
    &__room {
      flex-wrap: wrap;
      margin-bottom: 20px;
    }

    &__room-name {
      flex-basis: calc(100% - 52px);
      order: -2;
      margin-bottom: 10px;
    }

    &__btn-remove-room {
      margin-right: 0;
      order: -1;
    }

    &__room-area {
      flex-basis: 100%;
      margin-right: 0;
    }

    &__footer {
      flex-direction: column;
      gap: 20px;
      align-items: center;
    }
  }
}
</style>
